import constants from "./constants";

export const PRIVACY_POLICY = {
  summary: `Thank you for using ${constants.APP_NAME}!

  ${constants.APP_NAME} exists to help mushroom farmers track their harvests and potentially become certified. In short—to make the mushroom growing process easier. We are a community built on trust and transparency. A fundamental part of earning that trust means being clear about how we use your information and protecting your human right to privacy.

This Privacy Policy describes how ${constants.APP_NAME}. and its affiliates (“we,” “us,” or “${constants.APP_NAME}”), process personal information in relation to your use of the ${constants.APP_NAME} Platform.`,
  sections: [
    {
      header: "Personal information we collect",
      paragraph: `We collect personal information about you and your farm when you use the ${constants.APP_NAME} platform. You provide us with your first name, last name, and email, in addition to the name of your farm. You can optionally provide us a logo image of your farm. If you opt in for a tier above the Free tier, we will collect payment information from you for the recurring monthly payment. `,
    },
    {
      header: "How we use the information we collect",
      paragraph: `We do not share, sell, or disclose your information to any third parties.
        
        We use the personal information you provide to us to enable you to access the ${constants.APP_NAME} Platform to track your mushroom farm's data, enable us to communicate directly with you via email, and allow you to purchase subscriptions and/or supplemental packages.`,
    },
  ],
};
